/*
 * You may also like (ranked): sections/ranked-related-products.liquid.
 *
 * The section's priorities (its settings, 1st to 4th) are rules in order. Each rule becomes one request for
 * candidate cards (sections/ranked-related-products-results.liquid rendered on /search or on a collection), all
 * requests run together, and the cards are then taken rule by rule, in priority order, until the section's
 * maximum. A product is shown once, the product being viewed never, and sold out ones only when the section
 * allows them.
 */
(function () {
  'use strict';

  // Words that make a different model when they follow a model name: "iPhone 17 Pro" is not "iPhone 17"
  var MODEL_SUFFIXES = ['pro', 'max', 'plus', 'air', 'ultra', 'fe', 'mini', 'lite', 'fold', 'flip', 'edge', 'neo', 'xl', 'e'];

  function splitList(text) {
    return String(text || '').split(',').map(function (part) {
      return part.trim();
    }).filter(Boolean);
  }

  function escapeRegExp(text) {
    return text.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  // "iPhone 17 256GB" -> "iPhone 17"; "Galaxy S26 FE 512GB" -> "Galaxy S26 FE". Storage, anything after it,
  // bracketed notes and a trailing " - condition" are dropped.
  function deviceModel(title) {
    return String(title || '')
      .replace(/\s*\([^)]*\)/g, ' ')
      .replace(/\s+\d+(?:\.\d+)?\s?(?:GB|TB)\b.*$/i, '')
      .replace(/\s+-\s+.*$/, '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  // True when a title names exactly this model, alone ("Case for iPhone 17") or in a combined listing
  // ("Glass for iPhone 17/17 Pro" fits both), but not a longer model ("iPhone 17 Pro", "iPhone 17e").
  function fitsModel(title, model) {
    if (!model) {
      return false;
    }

    var tokens = model.split(' ');
    var patterns = [escapeRegExp(model)];

    if (tokens.length > 1) {
      patterns.push('[/,&]\\s*' + escapeRegExp(tokens.slice(1).join(' ')));
    }

    var ending = '(?![\\w-])(?!\\s*(?:' + MODEL_SUFFIXES.join('|') + ')\\b)';

    return patterns.some(function (pattern) {
      return new RegExp(pattern + ending, 'i').test(title);
    });
  }

  function quote(value) {
    return '"' + String(value).replace(/"/g, '') + '"';
  }

  function anyOf(field, values) {
    var parts = values.map(function (value) {
      return field + ':' + quote(value);
    });

    return parts.length > 1 ? '(' + parts.join(' OR ') + ')' : parts[0];
  }

  // Storefront search query for a rule, or null when the rule cannot run for this product
  function searchQuery(rule, product) {
    switch (rule.type) {
      case 'same_type':
        return product.type ? 'product_type:' + quote(product.type) : null;

      case 'product_types': {
        var types = splitList(rule.types);
        return types.length ? anyOf('product_type', types) : null;
      }

      case 'same_brand':
        if (!product.vendor) {
          return null;
        }

        return 'vendor:' + quote(product.vendor) + (rule.sameTypeOnly && product.type ? ' AND product_type:' + quote(product.type) : '');

      case 'device_accessories': {
        var model = deviceModel(product.title);
        var accessoryTypes = splitList(rule.accessoryTypes);

        if (!model || !accessoryTypes.length) {
          return null;
        }

        // Search wide on family and number ("iPhone 17"), then fitsModel keeps the exact model
        var base = model.split(' ').slice(0, 2).join(' ');
        return 'title:' + quote(base) + ' AND ' + anyOf('product_type', accessoryTypes);
      }

      case 'tag':
        return rule.tag ? 'tag:' + quote(rule.tag) : null;

      default:
        return null;
    }
  }

  // Search matches words, so the rule's own condition is checked again on each candidate
  function acceptCandidate(rule, product, candidate) {
    var candidateType = String(candidate.type || '').toLowerCase();
    var productType = String(product.type || '').toLowerCase();

    switch (rule.type) {
      case 'same_type':
        return rule.similarTypes ? candidateType.indexOf(productType) !== -1 || productType.indexOf(candidateType) !== -1 : candidateType === productType;

      case 'product_types':
        return splitList(rule.types).some(function (type) {
          return type.toLowerCase() === candidateType;
        });

      case 'same_brand':
        return String(candidate.vendor || '').toLowerCase() === String(product.vendor || '').toLowerCase() &&
          (!rule.sameTypeOnly || candidateType === productType);

      case 'device_accessories':
        return splitList(rule.accessoryTypes).some(function (type) {
          return type.toLowerCase() === candidateType;
        }) && fitsModel(candidate.title, deviceModel(product.title));

      default:
        return true;
    }
  }

  // Closest price to the product being viewed first; ties keep the search order
  function orderCandidates(rule, product, candidates) {
    if (rule.order !== 'closest_price' || !product.price) {
      return candidates;
    }

    return candidates
      .map(function (candidate, index) {
        return { candidate: candidate, index: index, distance: Math.abs(candidate.price - product.price) };
      })
      .sort(function (a, b) {
        return a.distance - b.distance || a.index - b.index;
      })
      .map(function (entry) {
        return entry.candidate;
      });
  }

  if (typeof module === 'object' && module.exports) {
    module.exports = { deviceModel: deviceModel, fitsModel: fitsModel, searchQuery: searchQuery, acceptCandidate: acceptCandidate, orderCandidates: orderCandidates };
  }

  // Every instance of the section outputs the script tag; the listeners below need to exist once
  if (typeof document === 'undefined' || window.rankedRelatedLoaded) {
    return;
  }

  window.rankedRelatedLoaded = true;

  function ruleUrl(rule, config) {
    var params = new URLSearchParams();

    if (rule.type === 'collection') {
      if (!rule.collectionUrl) {
        return null;
      }

      params.set('section_id', config.resultsSection);
      return rule.collectionUrl + '?' + params.toString();
    }

    var query = searchQuery(rule, config);

    if (!query) {
      return null;
    }

    params.set('q', query);
    params.set('type', 'product');
    params.set('options[unavailable_products]', config.hideSoldOut ? 'hide' : 'last');

    // Storefront search sorts by price only; closest price is sorted after the fetch (orderCandidates)
    if (rule.order === 'price_high') {
      params.set('sort_by', 'price-descending');
    } else if (rule.order === 'price_low') {
      params.set('sort_by', 'price-ascending');
    }

    params.set('section_id', config.resultsSection);
    return config.searchUrl + '?' + params.toString();
  }

  function fetchCandidates(url) {
    if (!url) {
      return Promise.resolve([]);
    }

    return fetch(url, { credentials: 'same-origin' })
      .then(function (response) {
        return response.ok ? response.text() : '';
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');

        return Array.prototype.map.call(doc.querySelectorAll('[data-rr-item]'), function (item) {
          return {
            id: item.getAttribute('data-product-id'),
            type: item.getAttribute('data-type'),
            vendor: item.getAttribute('data-vendor'),
            title: item.getAttribute('data-title'),
            available: item.getAttribute('data-available') === 'true',
            price: parseInt(item.getAttribute('data-price'), 10) || 0,
            card: item.querySelector('.product-item')
          };
        });
      })
      .catch(function () {
        return [];
      });
  }

  // Prev and next page through the cards. The button at either end is disabled, which the theme's carousel
  // button style hides, so both are hidden when every card fits.
  function setupArrows(root) {
    var scroller = root.querySelector('[data-rr-scroller]');
    var prev = root.querySelector('[data-rr-prev]');
    var next = root.querySelector('[data-rr-next]');
    var frame = 0;

    if (!scroller || !prev || !next) {
      return;
    }

    function update() {
      frame = 0;

      var maxScroll = scroller.scrollWidth - scroller.clientWidth;
      var scrollable = maxScroll > 1;

      root.setAttribute('data-rr-scrollable', scrollable ? 'true' : 'false');
      prev.disabled = !scrollable || scroller.scrollLeft <= 1;
      next.disabled = !scrollable || scroller.scrollLeft >= maxScroll - 1;
    }

    function scheduleUpdate() {
      if (!frame) {
        frame = window.requestAnimationFrame(update);
      }
    }

    // Page by whole cards: next brings the first card cut off on the right to the start, prev goes back by
    // as many cards as fit. The start is where the first card sits unscrolled (the theme's phone gutter).
    function step(direction, button) {
      if (button.disabled) {
        return;
      }

      var origin = scroller.getBoundingClientRect().left - scroller.scrollLeft;
      var lefts = Array.prototype.map.call(root.querySelectorAll('[data-rr-list] > .product-item'), function (card) {
        var rect = card.getBoundingClientRect();
        return { left: rect.left - origin, right: rect.right - origin };
      });

      if (!lefts.length) {
        return;
      }

      var inset = lefts[0].left;
      var target = null;
      var i;

      if (direction > 0) {
        var viewEnd = scroller.scrollLeft + scroller.clientWidth;

        for (i = 0; i < lefts.length; i++) {
          if (lefts[i].right > viewEnd + 1) {
            target = lefts[i].left - inset;
            break;
          }
        }

        if (target === null) {
          target = scroller.scrollWidth;
        }
      } else {
        var wanted = scroller.scrollLeft - (scroller.clientWidth - inset);

        for (i = 0; i < lefts.length; i++) {
          if (lefts[i].left - inset >= wanted - 1) {
            target = lefts[i].left - inset;
            break;
          }
        }
      }

      scroller.scrollTo({ left: Math.max(0, target || 0), behavior: 'smooth' });
    }

    prev.addEventListener('click', function () {
      step(-1, prev);
    });

    next.addEventListener('click', function () {
      step(1, next);
    });

    scroller.addEventListener('scroll', scheduleUpdate, { passive: true });

    if (window.ResizeObserver) {
      new ResizeObserver(scheduleUpdate).observe(scroller);
    } else {
      window.addEventListener('resize', scheduleUpdate);
    }

    update();
  }

  function initSection(root) {
    if (!root || root.hasAttribute('data-rr-ready')) {
      return;
    }

    var configElement = root.querySelector('[data-rr-config]');
    var list = root.querySelector('[data-rr-list]');
    var note = root.querySelector('[data-rr-editor-note]');
    var config;

    try {
      config = JSON.parse(configElement.textContent);
    } catch (error) {
      return;
    }

    root.setAttribute('data-rr-ready', '');

    var rules = config.rules || [];

    Promise.all(rules.map(function (rule) {
      return fetchCandidates(ruleUrl(rule, config));
    })).then(function (results) {
      var shown = {};
      var added = 0;

      shown[String(config.productId)] = true;

      rules.forEach(function (rule, index) {
        var fromRule = 0;

        orderCandidates(rule, config, results[index]).forEach(function (candidate) {
          if (added >= config.maxProducts || fromRule >= rule.limit || !candidate.card || shown[candidate.id]) {
            return;
          }

          if ((config.hideSoldOut && !candidate.available) || !acceptCandidate(rule, config, candidate)) {
            return;
          }

          shown[candidate.id] = true;
          list.appendChild(document.importNode(candidate.card, true));
          fromRule++;
          added++;
        });
      });

      if (added) {
        root.hidden = false;
        setupArrows(root);
      } else if (note) {
        note.hidden = false;
      }

      root.setAttribute('data-rr-count', String(added));
    });
  }

  function initAll(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll('[data-ranked-related]'), initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
